import {
  MoovyContainer,
  MoovyContainerContent,
  MoovyTab
} from '../../components'

import { CatalogueResponseDTO } from '../../apis/catalogues/dto'
import TabCatalogue from './tabCatalogue'
import TabInvitations from './tabInvitations'
import useAuth from '../../hooks/useAuth'
import { useIntl } from 'react-intl'
import TabAdministrators from '../customers/customer/tabAdministrators'

export type CatalogueTabsProps = {
  catalogue: CatalogueResponseDTO | undefined
}
const CatalogueTabs = ({ catalogue }: CatalogueTabsProps) => {
  const intl = useIntl()
  const { admin, isPermission } = useAuth()

  // Invitations and administrators tabs are only shown for tenant customer type and logged users who are not admin
  const isVisible =
    catalogue?.customer.type === 'TENANT' &&
    !admin &&
    isPermission('READ', 'TENANT_INVITATIONS')

  let tabHeaders: string[] = [
    intl.formatMessage({
      id: 'page.places.catalogueTabs.catalogue.header'
    })
  ]
  let tabPanels = [<TabCatalogue catalogue={catalogue} />]

  if (isVisible) {
    tabHeaders.push(
      intl.formatMessage({
        id: 'page.places.catalogueTabs.administrators.header'
      }),
      intl.formatMessage({
        id: 'page.places.catalogueTabs.invitations.header'
      })
    )
    tabPanels.push(
      <TabAdministrators
        customerId={catalogue.customer.id}
        showInvitationCreate={false}
      />,
      <TabInvitations catalogue={catalogue} />
    )
  }

  return (
    <MoovyContainer loading={false}>
      <MoovyContainerContent>
        <MoovyTab
          tabKey="tabsRightHolderGroup"
          tabHeaders={tabHeaders}
          tabPanels={tabPanels}
        />
      </MoovyContainerContent>
    </MoovyContainer>
  )
}

export default CatalogueTabs
